import { LitElement, html } from 'vendor/lit'
import { getSection, getSectionId, imagesLoaded } from 'utils/gw'
// TODO: REWORK THIS TO JUST USE A GENERIC TOOLTIP COMPONENT
class HHProductSiblings extends LitElement {
  constructor() {
    super()

    this.section = getSection(this)
    this.sectionId = getSectionId(this)

    this.onSwatchClick = this.onSwatchClick.bind(this)
    this.onSwatchFocus = this.onSwatchFocus.bind(this)
    this.onSwatchBlur = this.onSwatchBlur.bind(this)
  }

  #initialised = false

  get productSiblings() {
    return this.querySelectorAll('[data-swatch]')
  }

  get tooltipContainer() {
    return this.querySelector('.swatches__tooltip')
  }

  connectedCallback() {
    super.connectedCallback()

    // this element can upgrade before its children are parsed, so defer a frame
    requestAnimationFrame(() => this.initSwatches())
  }

  initSwatches() {
    if (this.#initialised) return
    this.#initialised = true

    this.productSiblings.forEach(sibling => {
      sibling.addEventListener('mouseenter', this.onHoverTooltip.bind(this))
      sibling.addEventListener('mouseleave', this.onSwatchBlur)
    })

    this.initRovingTabindex()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    // this.removeEventListener('click', this.onSwatchClick)
  }

  async onSwatchClick(e) {
    e.preventDefault()
    e.stopPropagation()

    const swatch = e.target.closest('[data-swatch]')

    if (!swatch) return

    // const swatch = e.target
    // const productId = swatch.dataset.productId
    // const variantId = swatch.dataset.variantId
    console.log('CLICKED', swatch)

    // TODO: Adjust logic to replace specific portions of the section
    // TODO: -> Media / Content region separately
    // TODO: Alternatively, mark each color-specific chunk of markup and replace those from fetched version!
    try {
      const url = swatch.href
      console.log('SWATCH URL', url)
      const response = await fetch(`${url}?section_id=${this.sectionId}`)
      const markup = await response.text()
      // console.log('MARKUP', markup)

      const parser = new DOMParser()
      const doc = parser.parseFromString(markup, 'text/html')
      console.log('DOC SECTION', doc.querySelector('.shopify-section'))

      await imagesLoaded(doc.querySelector('.shopify-section'), { container: true })
      this.section.replaceWith(doc.querySelector('.shopify-section'))
      // this.section.outerHTML = markup
    } catch (error) {
      console.error('ERROR', error)
    }
  }
    /**
   * Collapses the swatch set to a single tab stop, navigated with arrow keys.
   * Without this a product with 20 colourways puts 20 stops between the top of
   * the dialog and the size picker, which is unreachable in practice.
   */
  initRovingTabindex() {
    const swatches = [...this.productSiblings]

    // a lone swatch is a plain link; nothing to rove between
    if (swatches.length < 2) return

    const selected = swatches.findIndex(swatch => swatch.classList.contains('is-selected'))
    this.setRovingIndex(selected > -1 ? selected : 0)

    this.addEventListener('keydown', this.onSwatchKeyDown)
    swatches.forEach(swatch => {
      swatch.addEventListener('focus', this.onSwatchFocus)
      swatch.addEventListener('blur', this.onSwatchBlur)
    })
  }

  setRovingIndex(index) {
    [...this.productSiblings].forEach((swatch, i) => {
      swatch.tabIndex = i === index ? 0 : -1
    })
  }

  onSwatchKeyDown(e) {
    const swatches = [...this.productSiblings]
    const current = swatches.indexOf(e.target.closest('[data-swatch]'))

    if (current === -1) return

    const last = swatches.length - 1
    let next

    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = current === last ? 0 : current + 1
        break
      case 'ArrowLeft':
      case 'ArrowUp':
        next = current === 0 ? last : current - 1
        break
      case 'Home':
        next = 0
        break
      case 'End':
        next = last
        break
      default:
        return
    }

    e.preventDefault()
    this.setRovingIndex(next)
    swatches[next].focus()
  }

  onSwatchFocus(e) {
    // keep the tab stop on whatever was focused last, including by pointer
    this.setRovingIndex([...this.productSiblings].indexOf(e.target))
    // mirror the hover tooltip so arrowing shows the colour name
    this.onHoverTooltip(e)
  }

  onSwatchBlur(e) {
    this.onHoverTooltip(e, true)
  }

  onHoverTooltip(e, close = false) {
    if (!this.tooltipContainer) return
    if (close) {
      this.tooltipContainer.style.top = ''
      this.tooltipContainer.style.left = ''
      this.tooltipContainer.innerHTML = ''
      this.tooltipContainer.classList.remove('is-hovered')
      return
    }

    e.preventDefault()
    const el = e.target
    const content = el.dataset.tooltip ?? el.dataset.swatch

    if (content === null) return
    this.tooltipContainer.textContent = content
    this.tooltipContainer.style.top = `${el.offsetHeight + el.offsetTop + 10}px`
    this.tooltipContainer.style.left = `${el.offsetLeft + el.offsetWidth / 2}px`
    this.tooltipContainer.classList.add('is-hovered')
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-siblings', HHProductSiblings)
